/* eslint-disable @typescript-eslint/no-explicit-any */
import { AjaxHttpClientAdapter } from 'breeze-client/adapter-ajax-httpclient';
import { DataServiceWebApiAdapter } from 'breeze-client/adapter-data-service-webapi';
import { ModelLibraryBackingStoreAdapter } from 'breeze-client/adapter-model-library-backing-store';
import { UriBuilderJsonAdapter } from 'breeze-client/adapter-uri-builder-json';

// import { DividerFormlyComponent } from './renderers/formly/divider.type';
import { AgGridModule } from '@ag-grid-community/angular';
import { AgCharts } from 'ag-charts-angular';
import { CommonModule } from '@angular/common';
import { ErrorHandler, inject, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { FormlyModule } from '@ngx-formly/core';
// import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FloatLabelModule } from 'primeng/floatlabel';
// import {FullCalendarModule} from 'primeng/fullcalendar';
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { KnobModule } from 'primeng/knob';
import { TextareaModule } from 'primeng/textarea';
// import { LightboxModule } from 'primeng/lightbox';
import { TiptapEditorDirective } from 'ngx-tiptap';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollerModule } from 'primeng/scroller';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { StepperModule } from 'primeng/stepper';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { TemplateRendererComponent } from './components/ag-grid/template-renderer.component';
import { AutoFocusModule } from 'primeng/autofocus';

import {
  AddressFrmComponent,
  AgGridWrapperComponent,
  BadgeRendererComponent,
  BaseListEditFrmComponent,
  ButtonRendererComponent,
  ChangeLogDialogComponent,
  ChangeLogGridComponent,
  CoreAccountFinderDialog,
  CoreJobOrderFinderDialog,
  CoreSupplierFinderDialog,
  CoreUserFinderDialog,
  DateCellEditorPngComponent,
  ChangeEmailPromptDialogComponent,
  EmailConflictDialogComponent,
  EntityFinderDialog,
  SaveErrorDialogComponent,
  ErrorDialogComponent,
  OrderIssuesDialogComponent,
  SupplierUnavailableDialogComponent,
  FileGalleryDialogComponent,
  GridToolTipValueDialog,
  IconRendererComponent,
  ProfileEditRequestDialogComponent,
  RoleRightsFrmComponent,
  TextboxDialogComponent,
  TextPromptDialogComponent,
  UrlViewDialogComponent,
  UserFrmComponent,
  UserFrmDialogComponent,
  ValidationDialogComponent,
} from './components';
// import { PanelWrapperComponent } from './renderers/old-formly/panel-wrapper.component';
import { ProxSaveCancelComponent, QuickSearchComponent } from './components';
// import { USDInputComponent } from './renderers/old-formly/usd-input.type';

import { HttpClient } from '@angular/common/http';
import { AngularSplitModule } from 'angular-split';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BreadcrumbService } from './components/breadcrumb/breadcrumb.service';
// import { ProxFieldComponent } from './components/prox-field.component';
import { BreezeValidatorDirective } from './components/breeze-validator.directive';
import { BaseService } from './services/base.service';
import { UtilDialogService } from './services/dialog.service';
import { ProxDialogServiceProvider } from './services/prox-dialog.service';
import { FileService } from './services/file.service';
// import { FocusedInputComponent } from './renderers';
import { SupplierEntityManagerProvider } from '@data';
import { ConfirmationService } from 'primeng/api';
import { BlobRendererComponent } from './components/ag-grid/blob-renderer.component';
import { EntityStateRendererComponent } from './components/ag-grid/entity-state-renderer.component';
import { HtmlEditorComponent } from './components/editor/html-editor.component';
import { KeyMenuDirective } from './components/editor/key-menu.directive';
import { ImageEditComponent } from './components/file/image-edit.component';
import { HelpDialogComponent } from './components/help/help-dialog.component';
import { ImpersonateDialogComponent } from './components/impersonation/impersonate-dialog.component';
import { ProxFieldComponent } from './components/prox-field.component';
import { QbFieldComponent } from './components/qb-field.component';
import { ProxMainComponent } from './components/prox-main.component';
import { PricedProductTypeFinderDialog } from './shared/priced-product-type-finder.dialog';

import { StatusChangeDialog } from './components/base/status-change.dialog';
import { SubMenuComponent } from './components/sub-menu/sub-menu.component';
import { SubMenuitemComponent } from './components/sub-menu/sub-menuitem.component';
import { GlobalErrorHandler } from './services/global-error-handler';

import { StatusService } from './services/status.service';
import { EventScheduleDialog } from './shared/event-schedule-dialog';

import { ImageCropperComponent } from 'ngx-image-cropper';
import { NgxGaugeModule } from 'ngx-gauge';
import { ChoiceDialogComponent } from './components/choice-dialog.component';
import { PageTitleComponent } from './components/page.title/page.title';
import { BusyService } from './services/busy.service';
import { GravatarService } from './services/gravatar.service';

import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RouterModule } from '@angular/router';
import { AddressShowFrmComponent } from './components/user/address-show-frm.component';
import { AvailableStatusDialogComponent } from './shared/available-status-dialog.component';
import { ImageInsertDialogComponent } from './components/editor/image-insert-dialog.component';
import { V } from '@angular/cdk/viewport-ruler.d-5b507354';
import { VerifyProceedComponent } from './services/verify-proceed.component';
import { ActivationChecklistComponent } from './components/activation-checklist.component';

const CUSTOM_COMPONENTS = [QuickSearchComponent];
const ANGULAR_MODULES = [FormsModule, ReactiveFormsModule, RouterModule];
const THIRD_PARTY_MODULES: unknown[] = [
  AngularSplitModule,
  AgGridModule,
  AgCharts,
  // NuvoImporterModule
];
const PROX_COMPONENTS = [
  TemplateRendererComponent,
  AgGridWrapperComponent,
  BaseListEditFrmComponent,
  EntityFinderDialog,
  EventScheduleDialog,
  ButtonRendererComponent,
  BadgeRendererComponent,
  EntityStateRendererComponent,
  GridToolTipValueDialog,
  StatusChangeDialog,
  PricedProductTypeFinderDialog,
  DateCellEditorPngComponent,
  IconRendererComponent,
  BlobRendererComponent,
  ProxMainComponent,
  ChangeLogDialogComponent,
  ChangeLogGridComponent,
  CoreUserFinderDialog,
  CoreAccountFinderDialog,
  CoreJobOrderFinderDialog,
  CoreSupplierFinderDialog,
  HtmlEditorComponent,
  ImageInsertDialogComponent,
  ImpersonateDialogComponent,
  KeyMenuDirective,
  PageTitleComponent,
];

const PRIMENG_MODULES: unknown[] = [
  AccordionModule,
  AutoCompleteModule,
  AutoFocusModule,
  AvatarModule,
  AvatarGroupModule,
  BadgeModule,
  BlockUIModule,
  BreadcrumbModule,
  ButtonModule,
  CalendarModule,
  CardModule,
  CarouselModule,
  CascadeSelectModule,
  CheckboxModule,
  ChipModule,
  ConfirmDialogModule,
  ConfirmPopupModule,
  ColorPickerModule,
  ContextMenuModule,
  DataViewModule,
  DatePickerModule,
  DialogModule,
  DividerModule,
  DropdownModule,
  FieldsetModule,
  FileUploadModule,
  FloatLabelModule,
  // FullCalendarModule, <- @fullcalendar not Angular 13 ready
  GalleriaModule,
  ImageModule,
  InplaceModule,
  InputNumberModule,
  InputMaskModule,
  InputSwitchModule,
  InputTextModule,
  TextareaModule,
  KnobModule,
  // LightboxModule,
  ListboxModule,
  MegaMenuModule,
  MenuModule,
  MenubarModule,
  MessageModule,
  MessagesModule,
  MultiSelectModule,
  OrderListModule,
  OrganizationChartModule,
  OverlayPanelModule,
  PaginatorModule,
  PanelModule,
  PanelMenuModule,
  PasswordModule,
  PickListModule,
  ProgressBarModule,
  ProgressSpinnerModule,
  RadioButtonModule,
  RatingModule,
  RippleModule,
  ScrollPanelModule,
  ScrollTopModule,
  SelectModule,
  SelectButtonModule,
  SidebarModule,
  SkeletonModule,
  SliderModule,
  SplitButtonModule,
  SplitterModule,
  StepsModule,
  StepperModule,
  TableModule,
  TabMenuModule,
  TabViewModule,
  TagModule,
  TerminalModule,
  TimelineModule,
  TieredMenuModule,
  ToastModule,
  ToggleButtonModule,
  ToolbarModule,
  TooltipModule,
  //TreeModule, <= development time error re: @ciclon/angular-tree-component
  TreeTableModule,
  ScrollerModule,
];
/* these don't seem to be used anywhere
export function minlengthValidationMessage(err: any, field: any) {
  return `Must be at least ${field.templateOptions.minLength} characters`;
}

export function maxlengthValidationMessage(err: any, field: any) {
  return `Must be be less than ${field.templateOptions.maxLength} characters`;
}

export function minValidationMessage(err: any, field: any) {
  return `This value should be more than ${field.templateOptions.min}`;
}

export function maxValidationMessage(err: any, field: any) {
  return `This value should be less than ${field.templateOptions.max}`;
}

export function requiredValidationMessage(err: any, field: any) {
  return `${field.templateOptions.label} is required`;
}

export function emailValidator(control: AbstractControl): ValidationErrors {
  if (control.value?.trim().length <= 0) return null as any;
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(control.value) ? (null as any) : { email: true };
}

export function emailValidationMessage() {
  return `Not a valid email address`;
}
*/
@NgModule({
  imports: [
    CommonModule,
    ANGULAR_MODULES,
    PRIMENG_MODULES,
    THIRD_PARTY_MODULES,
    ImageCropperComponent,
    NgxGaugeModule,
    NgxChartsModule,
    TiptapEditorDirective,
  ],
  declarations: [
    PROX_COMPONENTS,
    CUSTOM_COMPONENTS,
    // USDInputComponent,
    // FocusedInputComponent,
    QuickSearchComponent,
    BreadcrumbComponent,
    SaveErrorDialogComponent,
    EmailConflictDialogComponent,
    ChangeEmailPromptDialogComponent,
    ErrorDialogComponent,
    OrderIssuesDialogComponent,
    SupplierUnavailableDialogComponent,
    ValidationDialogComponent,
    TextboxDialogComponent,
    TextPromptDialogComponent,
    ChoiceDialogComponent,
    HelpDialogComponent,
    UserFrmComponent,
    UserFrmDialogComponent,
    ProfileEditRequestDialogComponent,
    RoleRightsFrmComponent,
    ProxFieldComponent,
    QbFieldComponent,
    BreezeValidatorDirective,
    ProxSaveCancelComponent,
    AddressFrmComponent,
    FileGalleryDialogComponent,
    UrlViewDialogComponent,
    ImageEditComponent,
    SubMenuComponent,
    SubMenuitemComponent,
    AddressShowFrmComponent,
    AvailableStatusDialogComponent,
    VerifyProceedComponent,
    ActivationChecklistComponent,
  ],
  exports: [
    ANGULAR_MODULES,
    PRIMENG_MODULES,
    THIRD_PARTY_MODULES,
    PROX_COMPONENTS,
    CUSTOM_COMPONENTS,
    // FocusedInputComponent,
    BreadcrumbComponent,
    SaveErrorDialogComponent,
    EmailConflictDialogComponent,
    ChangeEmailPromptDialogComponent,
    ValidationDialogComponent,
    TextboxDialogComponent,
    TextPromptDialogComponent,
    HelpDialogComponent,
    UserFrmComponent,
    UserFrmDialogComponent,
    ProfileEditRequestDialogComponent,
    RoleRightsFrmComponent,
    ProxFieldComponent,
    QbFieldComponent,
    BreezeValidatorDirective,
    ProxSaveCancelComponent,
    AddressFrmComponent,
    AddressShowFrmComponent,
    FileGalleryDialogComponent,
    ImageEditComponent,
    UrlViewDialogComponent,
    AvailableStatusDialogComponent,
    SubMenuComponent,
    SubMenuitemComponent,
    AgCharts,
    ActivationChecklistComponent,
  ],
  providers: [
    ConfirmationService,
    ProxDialogServiceProvider,
    BreadcrumbService,
    UtilDialogService,
    BaseService,
    FileService,
    StatusService,

    GravatarService,
    {
      // processes all errors
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
})
export class CoreModule {
  constructor(http: HttpClient) {
    ModelLibraryBackingStoreAdapter.register();
    UriBuilderJsonAdapter.register();
    AjaxHttpClientAdapter.register(http);
    DataServiceWebApiAdapter.register();

    const emProvider = inject(SupplierEntityManagerProvider);
    emProvider.prepare();
  }
}
